import React, { useRef, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  Table,
  styled,
} from "@mui/material";
import { Container, TableContainer, TableHead } from "@mui/material";
import { TableRow, TableBody, TableCell, Box } from "@mui/material";
import "../../App.css";
import moment from "moment";
import StandardPrint from "../resusablePrints/StandardPrint";
import StandardTwo from "../resusablePrints/StandardTwo";
import ThermalPrint from "../resusablePrints/ThermalPrint";
import OnlyWarehousePrint from "../resusablePrints/OnlyWarehousePrint";
import ClipLoader from "react-spinners/ClipLoader";
import ReturnPrint from "../resusablePrints/ReturnPrint";
import { convertToRFT } from "../../utils/convertToRFT";
import ReactToPrint from "react-to-print";
import { ComponentToPrint } from "../resusablePrints/InvoicePrint";
import { Stack, Typography } from "@mui/material";
import { BoxesPacking } from "../features/BoxesPacking";
import { UserDetailsPrint } from "../user details/Print";
import {
  saveBillToIndexedDB,
  getBillsFromIndexedDB,
  deleteBillFromIndexedDB,
} from "../point of sale/IndexDb";
import StandardNewTwoPrint from "../resusablePrints/StandardNewTwoPrint";
import NewStandardPrint from "../resusablePrints/NewStandardPrint";
import StandardUserPrint from "../resusablePrints/StandardUserPrint";
import DesignFivePrint from "../resusablePrints/DesignFivePrint";
import DesignSixPrint from "../resusablePrints/DesignSixPrint";
import DesignSevenPrint from "../resusablePrints/DesignSevenPrint";

import { useSelector } from "react-redux";
const BillPreviewComp = styled(Box)({
  position: "relative",
  zoom: 1,
  minWidth: "235mm",
  maxWidth: "235mm",
  minHeight: "150mm",
  maxHeight: "maxContent",
  backgroundColor: "white",
  padding: "10px",
});
const ButtonPrint = styled(Button)({
  backgroundColor: "#4caf50",
  fontWeight: "bold",
  borderRadius: "5px",
  color: "white",
  textTransform: "none",
  marginLeft: "10px",
  boxShadow: "0px 2px 3px rgb(161, 161, 161)",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#4caf50",
  },
});

const StoreInfo = styled(Typography)({
  padding: "2px 10px 2px 10px",
  backgroundColor: "#4caf50",
  color: "white",
  width: "250px",
  margin: "5px 0px",
});
const Comments = styled(Typography)({
  position: "relative",
  //   top: -180px,
  width: "400px",
  height: "150px",
  border: "2px solid #cecdcd",
});

const styles = `
@media all {
  .pagebreak {
    display: none;
  }
}
@media print {
  .pagebreak {
    page-break-before: always;
  }
}
`;

function BillPreview({
  title,
  open,
  onSale = "",
  onQuotation = "",
  onClose,
  bill,
  sellItem = "",
  returnBillPrint = "",
  fivePercent = "",
  invoicePrint = "",
  storeBill,
}) {
  console.log("billlllll", bill);

  const newBill = bill?.items?.reduce((acc, item) => {
    const price =
      item.saleType == "pieces"
        ? item.pricePerPiece
        : Number(item.salePrice ?? item.price);
    const quantity = Number(item.saleQuantity ?? item.quantity);

    const total = price * quantity;
    console.log(";m", total);
    const totalCalulated = acc + total;
    return totalCalulated;
  }, 0);

  const findSubTotalNotReturn = () => {
    let count = 0;
    bill?.items?.forEach((item) => {
      let { totalPrice } = convertToRFT(bill.saleType, item, "", "ignore");
      count += Number(totalPrice);
    });
    console.log("ttoal", count);
    return count % 1 === 0 ? count : count.toFixed(3);
  };

  // console.log('...', newBill)
  const companyCode = localStorage.getItem("companyCode");
  const componentRef = useRef(bill);
  const [loading, setLoading] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const currency = useSelector((state) => state.employee.currency);
  const { company } = useSelector((state) => state.company);
  console.log("itemsss", bill);
  //  const costPriceBatchInside = bill.items?.map((item,index)=> {
  //   return item.batchNumber?.[0]?.newItem?.costPrice ?? null;
  //  })
  const totalBatch = bill.items?.reduce((acc, curr) => {
    console.log("currrrrr", curr);
    const salePriceBatchInside = curr?.batchNumber?.[0]?.newItem?.price ?? null;

    return acc + salePriceBatchInside * curr?.saleQuantity;
  }, 0);

  // const totalBatch =  Number(salePriceBatchInside) * Number(saleQty);
  console.log("is", isOnline);
  console.log("companyProfile", company);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [isOnline]);
  const print = (printType, Quote) => {
    let temp = localStorage.getItem("template");

    console.log("newBill", newBill);

    if (Quote == "Quotation") {
      if (temp == "thermal") {
        ThermalPrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          totalAmount: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          fivePercent: fivePercent,
          varTotal: bill?.varTotal,
          currency: currency,
        });
      } else {
        StandardPrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          subTotal: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          argSell: "",
          notes: bill.notes,
          idString: bill?.idString,
          ledger_id: bill?.ledger_id,
          newLedgerName: bill?.newLedgerName,
          printQuote: bill.printQuote,
          Quote: "Quotation",
          varTotal: bill?.varTotal,
          currency: currency,
        });
      }
    } else if (printType == "returnBillPrint") {
      let findSubTotal = findTotal();
      ReturnPrint({
        billNumber: bill.billNumber,
        customer: bill.customerName ? bill.customerName : bill.customer,
        items: bill.items,
        discount: bill.discount,
        discountType: bill.discount_type,
        date: bill.created_at
          ? moment.unix(bill.created_at).format("DD-MM-YYYY")
          : bill.date,
        subTotal: findSubTotal,
        Total: bill.total,
        paid: bill.paid,
        change: bill.change,
        notes: bill.notes,
        saleType: bill.saleType,
        varTotal: bill?.varTotal,
        currency: currency,
      });
    } else {
      if (temp == "thermal" || temp == "thermalInvoice") {
        ThermalPrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          totalAmount: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          fivePercent: fivePercent,
          printQuote: bill.printQuote,
          varTotal: bill?.varTotal,
          paymentMethod: bill?.paymentMethod,
          bankName: bill?.bankName,
          cheque: bill?.cheque,
          clearBalance: bill?.clearBalance,
          currency: currency,
          companyNew: company,

        });
      } else if (temp == "standard_user") {
        StandardUserPrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          subTotal: bill.subTotal,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          totalAmount: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          fivePercent: fivePercent,
          printQuote: bill.printQuote,
          varTotal: bill?.varTotal,
          ledger_address: bill.ledger_address,
          paymentMethod: bill?.paymentMethod,
          bankName: bill?.bankName,
          cheque: bill?.cheque,
          currency: currency,
        });
      } else if (temp == "design_five") {
        DesignFivePrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          subTotal: bill.subTotal,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          totalAmount: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          fivePercent: fivePercent,
          printQuote: bill.printQuote,
          varTotal: bill?.varTotal,
          ledger_address: bill.ledger_address,
          paymentMethod: bill?.paymentMethod,
          bankName: bill?.bankName,
          cheque: bill?.cheque,
          currency: currency,
          companyNew: company,
        });
      } else if (temp == "design_six") {
        DesignSixPrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          subTotal: bill.subTotal,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          totalAmount: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          fivePercent: fivePercent,
          printQuote: bill.printQuote,
          varTotal: bill?.varTotal,
          ledger_address: bill.ledger_address,
          paymentMethod: bill?.paymentMethod,
          bankName: bill?.bankName,
          cheque: bill?.cheque,
          currency: currency,
          companyNew: company,
        });
      } else if (temp == "design_seven") {
        DesignSevenPrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          subTotal: bill.subTotal,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          totalAmount: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          fivePercent: fivePercent,
          printQuote: bill.printQuote,
          varTotal: bill?.varTotal,
          ledger_address: bill.ledger_address,
          paymentMethod: bill?.paymentMethod,
          bankName: bill?.bankName,
          cheque: bill?.cheque,
          currency: currency,
          companyNew: company,
        });
      } else if (temp == "standard_urdu") {
        NewStandardPrint({
          billNumber: bill.billNumber,
          customer: bill.customerName ? bill.customerName : bill.customer,
          items: bill.items,
          discount: bill.discount,
          discountType: bill.discount_type,
          discount_text: bill.discount_text,
          subTotal: bill.subTotal,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          totalAmount: bill.subTotal,
          Total: bill.total,
          paid: bill.paid,
          outstandingBalance: bill.outstandingBalance,
          change: bill.change,
          formallyOutstandings: bill.formallyOutstandings,
          fivePercent: fivePercent,
          printQuote: bill.printQuote,
          varTotal: bill?.varTotal,
          ledger_address: bill.ledger_address,
          paymentMethod: bill?.paymentMethod,
          bankName: bill?.bankName,
          cheque: bill?.cheque,
          currency: currency,
          companyNew: company,

        });
      } else if (temp == "warehouse") {
        OnlyWarehousePrint({
          billNumber: bill.billNumber,
          items: bill.items,
          date: bill.created_at
            ? moment.unix(bill.created_at).format("DD-MM-YYYY")
            : bill.date,
          notes: bill.notes,
          currency: currency,
        });
      } else {
        if (temp == "standardTwo" || temp == "standardTwoDeliveryChallan") {
          StandardNewTwoPrint({
            billNumber: bill.billNumber,
            customer: bill.customerName ? bill.customerName : bill.customer,
            items: bill.items,
            discount: bill.discount,
            discountType: bill.discount_type
              ? bill.discount_type
              : bill.discountType,
            discount_text: bill.discount_text,
            date: bill.created_at
              ? moment.unix(bill.created_at).format("DD-MM-YYYY")
              : bill.date,
            subTotal: bill.subTotal,
            Total: bill.total,
            paid: bill.paid,
            outstandingBalance: bill.outstandingBalance,
            change: bill.change,
            formallyOutstandings: bill.formallyOutstandings,
            notes: bill.notes,
            gst: bill?.gst,
            varTotal: bill?.varTotal,
            income: bill?.income,
            further: bill?.further,
            paymentMethod: bill?.paymentMethod,
            bankName: bill?.bankName,
            cheque: bill?.cheque,
            currency: currency,
            companyStore: company,

          });
        } else {
          StandardPrint({
            billNumber: bill.billNumber,
            customer: bill.customerName ? bill.customerName : bill.customer,
            items: bill.items,
            discount: bill.discount,
            discountType: bill.discount_type,
            discount_text: bill.discount_text,
            date: bill.created_at
              ? moment.unix(bill.created_at).format("DD-MM-YYYY")
              : bill.date,
            subTotal: bill.subTotal,
            Total: bill.total,
            paid: bill.paid,
            outstandingBalance: bill.outstandingBalance,
            change: bill.change,
            formallyOutstandings: bill.formallyOutstandings,
            argSell: "",
            saleType: bill?.saleType,
            notes: bill.notes,
            idString: bill?.idString,
            ledger_id: bill?.ledger_id,
            newLedgerName: bill?.newLedgerName,
            printQuote: bill.printQuote,
            fivePercent: fivePercent,
            gst: bill?.gst,
            gstType: bill?.gstType,
            varTotal: bill?.varTotal,
            income: bill?.income,
            further: bill?.further,
            paymentMethod: bill?.paymentMethod,
            bankName: bill?.bankName,
            cheque: bill?.cheque,
            currency: currency,
            company:company
          });
        }
      }
    }
  };

  // const printReciept = async (type) => {
  //   if (sellItem == true) {
  //     await onSale();
  //     print(type);
  //     onClose();
  //   }
  // };

  const printReciept = async (type) => {
    if (bill.printQuote == "true") {
      setLoading(true);
      if (sellItem == true) {
        await onQuotation();
        setLoading(false);
        print(type, "Quotation");
        onClose();
      }
    } else {
      if (sellItem == true) {
        console.log("sale");
          await onSale();
     
      
        print(type);
        onClose();
      } 
      else if (sellItem == false) {
        if (returnBillPrint == "true") {
          print("returnBillPrint");
          onClose();
        } else {
          console.log("saleTwo");

          print(type);
          onClose();
        }
      }
    }
  };
  const afterPrint = () => {
    onClose();
    let img = localStorage.getItem("invoiceImage");
    if (img) {
      localStorage.removeItem("invoiceImage");
    }
  };
  const findTotal = () => {
    let count = 0;
    bill?.items?.forEach((item) => {
      let { totalPrice } = convertToRFT(bill.saleType, item, "", "ignore");
      count += Number(totalPrice);
      // count += (Number(totalPrice) + Number(bill?.varTotal));
    });
    console.log("ttoal", count);
    return count;
  };
  const discountTotal = () => {
    let total;
    let discountAmount;

    if (bill.discount_type == "price") {
      total = findTotal() - Number(bill.discount);
    } else {
      discountAmount = (findTotal() / 100) * Number(bill.discount);
      console.log("discountamount", discountAmount);
      total = findTotal() - discountAmount;
    }
    console.log("tot", total);
    console.log("billllll", bill);

    return total;
  };

  let gstStatus = "";
  let gst = localStorage.getItem("gst");
  if (gst && gst != "undefined") {
    if (gst == "disabled") {
      gstStatus = "0";
    } else {
      gstStatus = gst;
    }
  } else {
    gstStatus = "0";
  }

  return (
    <div>
      <Dialog
        title={title}
        fullWidth
        maxWidth="md"
        open={open}
        onClose={onClose}
        style={{ minHeight: "500px" }}
      >
        <DialogContent dividers={scroll === "paper"}>
          {invoicePrint == "true" && (
            <div>
              <ButtonPrint onClick={onClose}>Go Back</ButtonPrint>
              {sellItem == "true" && (
                <>
                  <ReactToPrint
                    pageStyle={styles}
                    onBeforePrint={onSale}
                    trigger={() => <ButtonPrint>Print Reciept</ButtonPrint>}
                    onAfterPrint={() => afterPrint()}
                    content={() => componentRef.current}
                  />
                  <ComponentToPrint
                    sale="true"
                    bill={bill}
                    ref={componentRef}
                  />
                </>
              )}
              {!sellItem && (
                <>
                  <ReactToPrint
                    pageStyle={styles}
                    trigger={() => <ButtonPrint>Print Reciept</ButtonPrint>}
                    onAfterPrint={() => onClose()}
                    content={() => componentRef.current}
                  />
                  <ComponentToPrint bill={bill} ref={componentRef} />
                </>
              )}
            </div>
          )}

          {invoicePrint == "" && (
            <BillPreviewComp>
              <Container>
                <div style={{ marginBottom: "25px" }}>
                  {loading == true && (
                    <ClipLoader size={50} color="#4DAF51" loading={loading} />
                  )}
                  {loading == false && (
                    <>
                      <ButtonPrint onClick={onClose}>Go Back</ButtonPrint>
                      <ButtonPrint onClick={() => printReciept("English")}>
                        Save Bill
                      </ButtonPrint>
                    </>
                  )}
                </div>

                <Grid container>
                  <Grid item lg={4} md={4} sm={4}>
                    <h2 style={{ margin: "0px" }}>
                      {localStorage.getItem("company")}
                    </h2>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4}>
                    {bill?.printQuote == "true" && (
                      <h3 style={{ margin: "0px" }}>Quotation</h3>
                    )}
                  </Grid>
                  <Grid item lg={4} md={4} sm={4}>
                    <h2 style={{ margin: "0px" }}>BILL DETAIL</h2>
                    Bill Number : {bill.billNumber}
                    <br />
                    DATE :{" "}
                    {bill.created_at
                      ? moment.unix(bill.created_at).format("DD-MM-YYYY")
                      : bill.date}
                  </Grid>
                </Grid>
              </Container>
              <Grid container style={{ marginBottom: "30px" }}>
                <Grid item lg={4} md={4} sm={4}>
                  <StoreInfo>STORE </StoreInfo>
                  {localStorage.getItem("company")}
                  <br />
                  {localStorage.getItem("address")}
                  <br />
                  {localStorage.getItem("email")}
                  <br />
                  {localStorage.getItem("phone")}
                  <br />
                </Grid>
                <Grid item lg={4} md={4} sm={4}>
                  <StoreInfo>CUSTOMER</StoreInfo>
                  <Stack direction="column" alignItems="center" gap="1rem">
                    {bill.customerName ? bill.customerName : bill.customer}
                    <br />
                    {bill?.paymentMethod}
                    <br />
                    {bill?.bankName}
                    {/* <br/> */}
                    {bill?.cheque}
                  </Stack>

                  {bill.seller && (
                    <Stack marginTop="15px">
                      <Typography>Employee</Typography>
                      {bill.seller}
                    </Stack>
                  )}
                </Grid>
                {/* will be implement in future */}

                {/* <Grid item lg={4} md={4} sm={4}>
                {bill.newLedgerName && (
                  <>
                    <h3 className={classes.storeInfo}>Ledger </h3>
                    {bill.newLedgerName}
                  </>
                )}
                {bill.idString && bill.idString != "new" && (
                  <>
                    <h3 className={classes.storeInfo}>Ledger</h3>
                    {bill.idString?.name}
                  </>
                )}
                {!bill.newLedgerName &&
                  bill.idString &&
                  bill.idString !== "new" && (
                    <>
                      <h3 className="no-margin-padding">Balance</h3>
                      {bill.idString?.saleTotal
                        ? bill.idString?.saleTotal
                        : "0"}
                    </>
                  )}
              </Grid> */}
              </Grid>
              <TableContainer>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="customized table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Item</TableCell>
                      <TableCell>Description</TableCell>
                      {companyCode == 7149 ? null : (
                        <TableCell>Disc%</TableCell>
                      )}
                      <TableCell>Qty</TableCell>
                      <TableCell>Unit Price</TableCell>
                      <TableCell>Total Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {bill?.items?.map((item, index) => {
                      const costPriceBatchInside =
                        item?.batchNumber?.[0]?.newItem?.costPrice ?? null;
                      const salePriceBatchInside =
                        item?.batchNumber?.[0]?.newItem?.price ?? null;
                      const totalBatch =
                        Number(salePriceBatchInside) *
                        Number(item?.saleQuantity);
                      console.log("itiii", item);
                      let bonus = parseInt(item?.bonus) || 0;
                      let {
                        unit,
                        itemPrice,
                        saleQty,
                        totalPrice,
                        itemDiscount,
                      } = convertToRFT(bill.saleType, item, "", fivePercent);
                      let saleQuantity =
                        saleQty % 1 === 0 ? saleQty : saleQty.toFixed(3);
                      let boxes = 0;
                      if (BoxesPacking()) {
                        if (item.saleQuantity && item?.packing) {
                          let totalBox =
                            parseFloat(item.saleQuantity) / item.packing;
                          boxes =
                            totalBox % 1 === 0 ? totalBox : totalBox.toFixed(2);
                        } else {
                          if (item.saleQuantity == undefined && item?.packing) {
                            let totalBox = 1 / item.packing;
                            boxes =
                              totalBox % 1 === 0
                                ? totalBox
                                : totalBox.toFixed(2);
                          } else {
                            boxes = "";
                          }
                        }
                      }
                      console.log("log", item.saleType);
                      console.log("log", item);

                      return (
                        <TableRow key={index}>
                          <TableCell component="th">{index + 1}</TableCell>
                          <TableCell component="th">{item.name}</TableCell>
                          <TableCell component="th">
                            {item.description}
                          </TableCell>
                          {companyCode == 7149 ? null : (
                            <TableCell component="th">{itemDiscount}</TableCell>
                          )}

                          {BoxesPacking() ? (
                            <TableCell component="th">
                              <p style={{ margin: "0px", padding: "0px" }}>
                                {saleQuantity}
                                {item?.bonus && (
                                  <Typography>Bonus : {item.bonus}</Typography>
                                )}
                              </p>
                              <p style={{ margin: "0px", padding: "0px" }}>
                                {boxes} boxes
                              </p>
                            </TableCell>
                          ) : (
                            <TableCell component="th">
                              <Stack>
                                {saleQuantity + " " + unit}
                                {item?.bonus && (
                                  <Typography>Bonus : {item.bonus}</Typography>
                                )}
                              </Stack>
                            </TableCell>
                          )}

                          <TableCell component="th">
                            {item.saleType == "pieces"
                              ? item.pricePerPiece
                              : salePriceBatchInside || itemPrice.toFixed(2)}
                          </TableCell>
                          <TableCell component="th">
                            {totalPrice % 1 === 0
                              ? totalPrice || totalBatch
                              : totalPrice.toFixed(3)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid container style={{ marginTop: "100px" }}>
                <Grid item lg={6} md={6} sm={6}>
                  <Comments>
                    <h4
                      style={{
                        margin: "0",
                        padding: "2px",
                        backgroundColor: "#cecdcd",
                      }}
                    >
                      Comments Or Special Instructions
                    </h4>
                    {bill.notes}
                  </Comments>
                </Grid>
                <Grid item lg={6} md={6} sm={6}>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={6}>
                      <p className="no-margin-padding">SUB TOTAL </p>
                      {companyCode == 7149 ? null : (
                        <p className="no-margin-padding">DISCOUNTS </p>
                      )}

                      {companyCode == 1916 ? (
                        <p className="no-margin-padding">Var Total </p>
                      ) : null}

                      {returnBillPrint != "true" && (
                        <>
                          {companyCode == "197" ? (
                            <p className="no-margin-padding">GST </p>
                          ) : (
                            <p className="no-margin-padding">PREV BALANCE </p>
                          )}
                          <p className="no-margin-padding">CHANGE</p>
                          <p className="no-margin-padding">PAID </p>
                        </>
                      )}
                      <p className="no-margin-padding">TOTAL</p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6}>
                      {returnBillPrint == "true" && (
                        <p className="no-margin-padding">{findTotal()}</p>
                      )}
                      {returnBillPrint != "true" && (
                        <p className="no-margin-padding">
                          {findSubTotalNotReturn() || totalBatch || 0}
                        </p>
                      )}
                      {companyCode == 7149 || companyCode == 1495 ? (
                        `${gstStatus}%`
                      ) : (
                        <p className="no-margin-padding">
                          {bill.discount ? bill.discount : 0}
                          {companyCode == "1916" ? "AED" : currency}
                        </p>
                      )}
                      {companyCode == "1916" ? (
                        <p className="no-margin-padding">
                          {Number(bill.varTotal) || "0"}
                        </p>
                      ) : (
                        ""
                      )}

                      {returnBillPrint != "true" && (
                        <>
                          {companyCode == "197" ? null : (
                            <p className="no-margin-padding">
                              {bill.formallyOutstandings || "0"}
                            </p>
                          )}

                          {/* varTOTal is only for comapny code 1916 */}
                          <p className="no-margin-padding">
                            {bill?.paid -
                              ((discountTotal() +
                                Number(bill?.varTotal) +
                                Number(bill.formallyOutstandings)) %
                                1) ===
                            0
                              ? bill?.paid -
                                (discountTotal() +
                                  Number(bill?.varTotal) +
                                  Number(bill.formallyOutstandings))
                              : bill?.paid -
                                (
                                  discountTotal() +
                                  Number(bill?.varTotal) +
                                  Number(bill.formallyOutstandings)
                                ).toFixed(3)}
                            {/* {Math.abs((bill?.paid )- (findTotal() + Number(bill?.varTotal) + Number(bill.formallyOutstandings )) || 0).toFixed(3) } */}
                          </p>
                          <p className="no-margin-padding">{bill.paid}</p>
                        </>
                      )}
                      <p className="no-margin-padding">
                        {/* {(discountTotal() +
                          Number(bill?.varTotal ?? 0) +
                          Number(bill?.formallyOutstandings ?? 0)) %
                          1 ==
                        0
                          ? discountTotal() +
                            Number(bill?.varTotal ?? 0) +
                            Number(bill?.formallyOutstandings ?? 0){currency}
                          : (
                              discountTotal() +
                              Number(bill?.varTotal ?? 0) +
                              Number(bill?.formallyOutstandings ?? 0)
                            ).toFixed(3){currency}} */}
                        {(discountTotal() +
                          Number(bill?.varTotal ?? 0) +
                          Number(bill?.formallyOutstandings ?? 0)) %
                          1 ===
                        0
                          ? `${
                              discountTotal() +
                                Number(bill?.varTotal ?? 0) +
                                (bill.clearBalance
                                  ? Number(bill?.formallyOutstandings ?? 0)
                                  : 0) || totalBatch
                            } ${currency}`
                          : `${
                              (
                                discountTotal() +
                                Number(bill?.varTotal ?? 0) +
                                (bill.clearBalance
                                  ? Number(bill?.formallyOutstandings ?? 0)
                                  : 0)
                              ).toFixed(3) || totalBatch
                            } ${currency}`}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </BillPreviewComp>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default BillPreview;
